import { render, staticRenderFns } from "./PoolAdd.vue?vue&type=template&id=6af3bae9"
import script from "./PoolAdd.vue?vue&type=script&lang=ts"
export * from "./PoolAdd.vue?vue&type=script&lang=ts"
import style0 from "./PoolAdd.vue?vue&type=style&index=0&id=6af3bae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports